module.exports = __webpack_public_path__ + "static/elempanel2-8a7c1bf8299624cbaf21108d09be6587.png";